import { getSettlement, postTaxPdf } from "crud/auth.crud";
import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';

import { Link } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"
import { useSelector } from "react-redux";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Modal from "../../components/RopikCustom/Modal";
import Pagination from "pages/Custom/Pagination";

import moment from "moment";
import Util from "pages/Dashboard/Common/Util";
import loading from "../../assets/images/loading.gif";

const SettlementDetails = () => {
  const selector = useSelector(state => state)
  const [dataList, setDataList] = useState([])
  const [modalShow, setModalShow] = useState(false)
  const [user, setUser] = useState(selector.auth.user)
  const [detailData, setDetailData] = useState()
  const [page, setPage] = useState(1)
  const [onUpload, setOnUpload] = useState(false);
  const [pagesGroup, setPagesGroup] = useState(1);
  const [pageArr, setPageArr] = useState([pagesGroup, pagesGroup + 1, pagesGroup + 2, pagesGroup + 3, pagesGroup + 4]);
  const [contentCount, setContentCount] = useState();
  const [pdfUrl, setPdfUrl] = useState();

  const getDataList = async () => {
    setOnUpload(true)
    const params = {
      page: page,
      company: user.member_group?.[0]?.company_group?.id,
    }

    let url = '/summary_wearing/data_list_for_treatment/?page=' + params.page + '&company=' + params.company;

    const response = await getSettlement(url);
    let dataCount = response.data.count % 15 === 0 ? response.data.count / 15 : Math.floor(response.data.count / 15) + 1
    if (!contentCount || contentCount !== dataCount) {
      if(dataCount === 0){
        setContentCount(1)
      }else{
        setContentCount(dataCount)
      }
      let newArr = []
      for (let i = pagesGroup - 1; i < pagesGroup + 4; i++) {
        if (i + 1 <= dataCount) {
          newArr.push(i + 1)
        }
      }
      if(newArr.length === 0) newArr = [1]
      setPageArr(newArr)
    }
    if (response.status === 200) {
      const content = response.data?.results || [];
      if (content.length > 0) {
        setDataList([...content])
      } else {
        setDataList(false)
      }
    }
    setOnUpload(false)
  }
  
  const modalClose = () => {
    setModalShow(false)
  }

  const clickList = async (item) => {
    setDetailData(item);
    setModalShow(true)
  }

  useEffect(() => {
    getDataList()
  }, [page])

  return (
    // <React.Fragment>
    //   <div className="page-content">
    //     <MetaTags>
    //       <title>정산상세내역 / 웨이스트버스</title>
    //     </MetaTags>
    //     <Container fluid>
    //       {/* Render Breadcrumbs */}
    //       <Breadcrumbs maintitle="Home" title="청구서" breadcrumbItem="정산상세내역" />

    <Row>
      <Col xs="12">
        <div className="email-rightbar mb-3">
          <Card>
            <div className="radius-4 overflow-hidden">
              <div className="table-responsive">
                <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                  <thead className="chart-thead">
                    <tr>
                      <th scope="col">ID</th>
                      <th scope="col">업체명</th>
                      <th scope="col">거래일자</th>
                      <th scope="col">인수량(kg)</th>
                      <th scope="col">고지 금액(원)</th>
                      <th scope="col">완납여부</th>
                    </tr>
                  </thead>
                  <tbody className="chart-tbody">

                    {
                      dataList && dataList.map((item, index) => {
                        return (
                          <tr key={item.id + '_' + index}>
                            <td className="pointer" onClick={() => {
                              clickList(item)
                            }}>{item.id}</td>
                            <td className="pointer" onClick={() => {
                              clickList(item)
                            }}>{item.collection_company.name}</td>
                            <td className="pointer" onClick={() => {
                              clickList(item)
                            }}>{moment(item.summary_date).format('YYYY-MM-DD')}</td>
                            <td className="pointer" onClick={() => {
                              clickList(item)
                            }}>{Util.setCommaPrice(item.qty_kg)}</td>
                            <td className="pointer" onClick={() => {
                              clickList(item)
                            }}>{Util.setCommaPrice(item.total_price)}</td>
                            <td className="pointer" onClick={() => {
                              clickList(item)
                            }}>{item.state === 'Y' ? '완납' : item.state === 'N' ? '미납' : '부분납부'}</td>
                          </tr>
                        )
                      })
                    }
                    {!dataList &&
                      <tr >
                        <td scope="row" colSpan="6">데이터가 없습니다.</td>
                      </tr>
                    }

                  </tbody>
                </table>
              </div>
            </div>
          </Card>

          <Pagination contentCount={contentCount} pageArr={pageArr} pageCallBack={(page)=>{setPage(page)}} />

        </div>
      </Col>
      {onUpload && <div style={{
        position: "absolute",
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: 'rgba(255, 255, 255, 0.6)',
        zIndex: 999,
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img src={loading} alt="로딩중입니다." width={'5%'}></img>
      </div>}
      <Modal title={'정산 내역 상세'} show={modalShow} onHide={modalClose} size="md">
        <div style={{ padding: 12 }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ fontSize: 16 }}>업체명</p>
            <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold' }}>{detailData?.collection_company.name}</p>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ fontSize: 16 }}>인수량</p>
            <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold' }}>{Util.setCommaPrice(detailData?.qty_kg)} Kg</p>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ fontSize: 16 }}>금액</p>
            <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold' }}>{Util.setCommaPrice(detailData?.price)} 원</p>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ fontSize: 16 }}>VAT</p>
            <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold' }}>{Util.setCommaPrice(detailData?.vat)} 원</p>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ fontSize: 16 }}>고지 금액</p>
            <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold' }}>{Util.setCommaPrice(detailData?.total_price)} 원</p>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ fontSize: 16 }}>납부 금액</p>
            <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold' }}>{Util.setCommaPrice(detailData?.payed_price)} 원</p>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ fontSize: 16 }}>미납 금액</p>
            <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold' }}>{Util.setCommaPrice(detailData?.total_price - detailData?.payed_price)} 원</p>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ fontSize: 16 }}>완납 여부</p>
            <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold' }}>{detailData?.state === 'Y' ? '완납' : detailData?.state === 'N' ? '미납' : '부분납부'}</p>
          </div>
        </div>
      </Modal>
    </Row>
    //     </Container>
    //   </div>
    // </React.Fragment>
  )
}

export default SettlementDetails
